import React from 'react';
import { Row, OuterIndent } from '../../../Layouts';
import { MemberRowHeaderItem } from './style';

export const MembershipTypesRowHeader = () => {
    return (
        <OuterIndent indent={'16px 0'}>
            <Row justify={'space-between'} style={{ width: 'auto' }}>
                <MemberRowHeaderItem minWidth={'200px'}>Name</MemberRowHeaderItem>
                <MemberRowHeaderItem minWidth={'120px'}>Class limit</MemberRowHeaderItem>
                <MemberRowHeaderItem minWidth={'80px'}>Credits</MemberRowHeaderItem>
                {/* <MemberRowHeaderItem minWidth={'150px'}>Usage limit</MemberRowHeaderItem> */}
                <MemberRowHeaderItem minWidth={'100px'}>Expiry</MemberRowHeaderItem>
                <MemberRowHeaderItem minWidth={'150px'}>Expiration date</MemberRowHeaderItem>
                <MemberRowHeaderItem minWidth={'80px'}>Price</MemberRowHeaderItem>
                <MemberRowHeaderItem minWidth={'135px'}>Installments</MemberRowHeaderItem>
                <MemberRowHeaderItem minWidth={'120px'}># Installments</MemberRowHeaderItem>
                <MemberRowHeaderItem minWidth={'100px'}>Sign up fee</MemberRowHeaderItem>
                <MemberRowHeaderItem minWidth={'200px'}>Classes in programme</MemberRowHeaderItem>
                <MemberRowHeaderItem minWidth={'50px'} />
            </Row>
        </OuterIndent>
    );
};



// WEBPACK FOOTER //
// ./src/UI/Components/Rows/MembershipPlanRow/Header.js